export const copyToClipboard = (
    contentMarkdown: string,
    markdownPreviewRef: React.RefObject<HTMLDivElement>,
    setCopyFeedback: (feedback: string) => void
  ) => {
    try {
      const tempDiv = document.createElement('div')
      const markdownRenderer = markdownPreviewRef.current?.cloneNode(true) as HTMLDivElement
      if (markdownRenderer) {
        navigator.clipboard.write([
          new ClipboardItem({
            'text/html': new Blob([markdownRenderer.innerHTML], { type: 'text/html' }),
            'text/plain': new Blob([contentMarkdown], { type: 'text/plain' }),
          }),
        ]).then(() => {
          setCopyFeedback('Copied!')
          setTimeout(() => setCopyFeedback(''), 2000)
        }).catch((err) => {
          console.error('Failed to copy: ', err)
          setCopyFeedback('Copy failed')
          setTimeout(() => setCopyFeedback(''), 2000)
        })
      } else {
        navigator.clipboard.writeText(contentMarkdown).then(() => {
          setCopyFeedback('Copied as text!')
          setTimeout(() => setCopyFeedback(''), 2000)
        })
      }
    } catch (err) {
      console.error('Clipboard copy failed:', err)
      setCopyFeedback('Copy failed')
      setTimeout(() => setCopyFeedback(''), 2000)
    }
  }
  
  export const extractSectionsFromMarkdown = (markdown: string): { id: string; title: string; content: string }[] => {
    const sections: { id: string; title: string; content: string }[] = []
    const lines = markdown.split('\n')
    let currentSectionTitle = ''
    let currentSectionContent: string[] = []
    let sectionCount = 0
    let inSection = false
    const sectionRegex = /^:::\s*section\s+(.*)$/
  
    lines.forEach((line) => {
      const sectionStart = sectionRegex.exec(line)
      const sectionEnd = line.trim() === ':::'
      if (sectionStart) {
        inSection = true
        currentSectionTitle = sectionStart[1]?.trim() || 'Unnamed Section'
      } else if (sectionEnd && inSection) {
        inSection = false
        if (currentSectionTitle) {
          sectionCount++
          const sectionId = `section-${sectionCount}`
          sections.push({ id: sectionId, title: currentSectionTitle, content: currentSectionContent.join('\n').trim() })
        }
        currentSectionTitle = ''
        currentSectionContent = []
      } else if (inSection) {
        currentSectionContent.push(line)
      }
    })
    return sections
  }